import React, { Fragment } from 'react';

// Components
import SummaryItem from './SummaryItem';

// Utils
import { toUTCAndFormat } from '@utils/dates/date.utils';
import { MM_SLASH_DD_SLASH_YYYY } from '@utils/dates/dateFormats.utils';
import { NO_PRIOR_DATA, SSAP_JSON_RESIDENCY_PROPS } from '@constants/ssap/miscellaneous/miscellaneous';
import { useIntl } from 'react-intl';
import { residencyDependency } from '../../Page2_15';


const ResidencySummary = props => {

    const {
        index: i,
        additionalResidencyEnabled,
        residencyInfo,
        ...restProps
    } = props;

    if (!additionalResidencyEnabled) return;

    const intlApi = useIntl();

    const getFormatted = (residencyInfo = {}, name) => {
        let val = [];
        if (name === SSAP_JSON_RESIDENCY_PROPS.RESIDENCY_REASONS) {
            if (residencyInfo.stateResident) {
                val.push(intlApi.formatMessage({ id: 'ssap.input.label.stateResident' }));
            }
            if (residencyInfo.planToMakeHome) {
                val.push(intlApi.formatMessage({ id: 'ssap.input.legend.planToMakeHome' }));
            }
            if (residencyInfo.movedInDueToWork) {
                val.push(intlApi.formatMessage({ id: 'ssap.input.legend.movedInDueToWork' }));
            }
            if (residencyInfo.visitingForPersonalReason) {
                val.push(intlApi.formatMessage({ id: 'ssap.input.legend.visitingForPersonalReason' }));
            }
            if (residencyInfo.stateResident === false && residencyInfo.planToMakeHome === false && residencyInfo.movedInDueToWork === false && residencyInfo.visitingForPersonalReason === false) {
                val.push(intlApi.formatMessage({ id: 'ssap.input.label.none_of_above' }));
            }

            return val.join(', ') || NO_PRIOR_DATA;
        }
        return (name.includes('Date') && residencyInfo[name]) ? toUTCAndFormat(residencyInfo[name], MM_SLASH_DD_SLASH_YYYY) : residencyInfo[name];
    };

    return (
        <Fragment>
            {([SSAP_JSON_RESIDENCY_PROPS.RESIDENCY_REASONS, SSAP_JSON_RESIDENCY_PROPS.MOVED_RECENTLY, SSAP_JSON_RESIDENCY_PROPS.MOVE_IN_DATE]).map((item) => {
                return (
                    residencyDependency(residencyInfo, item) && residencyInfo?.[item] !== null && <SummaryItem
                        textCode={`ssap.input.legend.${item}`}
                        value={getFormatted(residencyInfo, item)}
                        desc={[
                            [
                                `taxHousehold.householdMember[${i}].householdContact.residencyInfo`,
                                getFormatted,
                                [item]
                            ]
                        ]}
                        summaryItemId={item}
                        {...restProps}
                    />
                );
            })}
        </Fragment>
    );

};

export default ResidencySummary;
